import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4efb0f52"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "rich-menu-wrapper main-content-wrapper" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "main-content-page-title" }, "リッチメニュー", -1))
const _hoisted_3 = { class: "rich-menu-page" }
const _hoisted_4 = {
  key: 0,
  class: "row mt-3 message-success"
}
const _hoisted_5 = { class: "input-group flex flex-column gap-2" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "title",
  for: "menu-title"
}, [
  /*#__PURE__*/_createTextVNode("タイトル"),
  /*#__PURE__*/_createElementVNode("span", { class: "required-text" }, " 必須 ")
], -1))
const _hoisted_7 = {
  key: 0,
  class: "p-error text-sm"
}
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "title input-group inline-block" }, [
  /*#__PURE__*/_createTextVNode("コンテンツ設定"),
  /*#__PURE__*/_createElementVNode("span", { class: "required-text" }, " 必須 ")
], -1))
const _hoisted_9 = { class: "input-group flex flex-wrap gap-3 radio-buttom-custom" }
const _hoisted_10 = { class: "flex align-items-center" }
const _hoisted_11 = {
  key: 0,
  class: "icon-lms icon-lms_rad-chosen radio-icon"
}
const _hoisted_12 = {
  key: 1,
  class: "icon-lms icon-lms_rad radio-icon"
}
const _hoisted_13 = { class: "flex align-items-center" }
const _hoisted_14 = {
  key: 0,
  class: "icon-lms icon-lms_rad-chosen radio-icon"
}
const _hoisted_15 = {
  key: 1,
  class: "icon-lms icon-lms_rad radio-icon"
}
const _hoisted_16 = {
  key: 1,
  class: "input-group flex flex-wrap gap-3 grid"
}
const _hoisted_17 = { class: "lg:col-3 sm:col-12" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "field" }, [
  /*#__PURE__*/_createElementVNode("label", { class: "title" }, "タブの数")
], -1))
const _hoisted_19 = { class: "field" }
const _hoisted_20 = { class: "lg:col-3 sm:col-12" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "field" }, [
  /*#__PURE__*/_createElementVNode("label", {
    for: "tab-height",
    class: "title"
  }, "タブの高さ")
], -1))
const _hoisted_22 = { class: "field" }
const _hoisted_23 = { class: "pl-4 tab-title" }
const _hoisted_24 = { class: "px-4 py-1" }
const _hoisted_25 = { class: "grid" }
const _hoisted_26 = { class: "left-area lg:ml-2" }
const _hoisted_27 = { class: "button-group flex justify-content-start -ml-2" }
const _hoisted_28 = ["onChange"]
const _hoisted_29 = { class: "right-area lg:col-7 md:col-12 sm:col-12" }
const _hoisted_30 = { class: "icon-with-text flex align-items-center mt-2 mb-4" }
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "pi pi-chevron-circle-down" }, null, -1))
const _hoisted_32 = { class: "font-bold ml-2" }
const _hoisted_33 = { class: "field flex flex-column align-items-start justify-content-between mt-4" }
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "white-space-nowrap" }, [
  /*#__PURE__*/_createTextVNode(" アクションタイプ "),
  /*#__PURE__*/_createElementVNode("span", { class: "required-text pl-2" }, " 必須 ")
], -1))
const _hoisted_35 = { class: "w-4" }
const _hoisted_36 = {
  key: 0,
  class: "p-error text-sm"
}
const _hoisted_37 = { class: "field flex flex-column align-items-start justify-content-between" }
const _hoisted_38 = ["for"]
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "required-text pl-2" }, " 必須 ", -1))
const _hoisted_40 = { class: "w-100" }
const _hoisted_41 = {
  key: 0,
  class: "p-error text-sm"
}
const _hoisted_42 = {
  key: 1,
  class: "p-error text-sm"
}
const _hoisted_43 = { class: "w-full flex justify-content-end align-items-end" }
const _hoisted_44 = { class: "grid grid-nogutter menu-template-wrapper" }
const _hoisted_45 = ["data-id"]

import { onBeforeMount, ref, inject } from "vue";
import axios from "axios";
import Toast from "primevue/toast";
import { useToast } from "primevue/usetoast";
import RadioButton from "primevue/radiobutton";
import InputNumber from "primevue/inputnumber";
import RouterUtils from "@/common/utils/router.util";
import ApiRouterConstants from "../constants/api.router.constants";
import RouterConstants from "../constants/router.constants";
import { RichMenuTemplateServices } from "../services";
import { ILinesMenuTemplate, ILinesMenuTemplateItem, ILinesMenuTemplateBlock } from "../typings";
import { useCookies } from "@vueuse/integrations/useCookies";
import InlineMessage from "primevue/inlinemessage";
import { set, get } from "@vueuse/core";


export default /*#__PURE__*/_defineComponent({
  __name: 'RichMenuRegistration',
  setup(__props) {

const toast = useToast();

const clinicId = ref(0);
const richmenuTemplates = ref<ILinesMenuTemplate[]>([]);
const isSuccess = ref(false);
const visible = ref(false);
const tabHeight = ref(10);
const menuTitle = ref("");
const menuType = ref("single");
const menuNumber = ref(1);
const selectedNumberOfTabs = ref(2);
const selectedTemplates = ref<ILinesMenuTemplate[]>([]);
const selectedItemsType = ref({});
const selectedItemsContent = ref({});
const currentTab = ref(0);
const validateErrors = ref(false);
const loading = ref(false);
const inputsUploadImage = ref([]);
const previewBox = ref([]);
const previewBoxError = ref([]);
const showURLValidationError = ref(false);
const numberOfTabs = ref([
  { name: "2", value: 2 },
  { name: "3", value: 3 },
  { name: "4", value: 4 },
  { name: "5", value: 5 },
  { name: "6", value: 6 },
]);
const defaultTemplate = ref<ILinesMenuTemplate>({
  id: 1,
  items: {
    A: {
      width: "100%",
      height: "100%",
      position: 1,
    },
  },
});
const menuItemTypes = ref([{ name: "リンク", code: "uri" }]);

const isSelectedTemplate = (templateId: number) => {
  return selectedTemplates.value[currentTab.value]?.id == templateId;
};

const blockStyle = (block: ILinesMenuTemplateItem): ILinesMenuTemplateBlock => {
  return {
    float: "left",
    height: block.height,
    width: block.width,
  };
};

const onChangeTabNumber = () => {
  if (menuType.value == "tabs") {
    menuNumber.value = selectedNumberOfTabs.value;
  } else {
    menuNumber.value = 1;
  }
};

const chooseTemplate = () => {
  document.querySelectorAll(".menu-template-wrapper .template-wrapper").forEach(element => {
    element.classList.remove("selected");
  });
  event.currentTarget.classList.add("selected");
};

const openTemplatePopup = n => {
  visible.value = true;
  currentTab.value = n;
};

const handleSelectTemplate = () => {
  document.querySelectorAll(".menu-template-wrapper .template-wrapper").forEach(element => {
    if (element.classList.contains("selected")) {
      selectedTemplates.value[currentTab.value] = richmenuTemplates.value.find(
        template => template.id == element.dataset.id
      ) as ILinesMenuTemplate;
    }
  });
  visible.value = false;
};

const filterObjectByTabIndex = (object, tabIndex) => {
  const asArray = Object.entries(object);
  const filtered = asArray.filter(([key, _value]) => parseInt(key.split("-")[1]) == tabIndex + 1);

  return Object.fromEntries(filtered);
};

const backToList = () => RouterUtils.goTo(RouterConstants.RICH_MENU_ROUTER_NAME);

const createRichMenu = () => {
  loading.value = true;

  if (validates()) {
    loading.value = false;
    return;
  }

  const data = [...Array(menuNumber.value).keys()].map(menuIndex => {
    const itemsType = filterObjectByTabIndex(selectedItemsType.value, menuIndex);
    const itemsContent = filterObjectByTabIndex(selectedItemsContent.value, menuIndex);

    return {
      template_id: selectedTemplates.value[menuIndex + 1]?.id || 1,
      items: Object.keys(itemsType).map(key => {
        return {
          item_type: itemsType[key].code,
          content: itemsContent[key],
          position_name: key.split("-")[0],
        };
      }),
    };
  });

  var formData = new FormData();
  formData.append("title", menuTitle.value);
  formData.append("group_type", menuType.value == "single" ? "single_menu" : "tab_menu");
  formData.append("tab_height", tabHeight.value);
  formData.append("number_of_tabs", menuNumber.value);
  [...Array(menuNumber.value).keys()].forEach(menuIndex => {
    formData.append("images[]", inputsUploadImage.value[menuIndex + 1].files[0]);
  });
  formData.append("menus", JSON.stringify(data));

  const { get: getCookie } = useCookies();
  const token = getCookie("access_token");
  const urlRequest = ApiRouterConstants.API_RICH_MENUS + "?clinic_id=" + get(clinicId.value);
  axios
    .post(urlRequest, formData, {
      headers: {
        Accept: "application/json",
        "Content-Type": "multipart/form-data",
        Authorization: "Bearer " + token,
      },
    })
    .then(() => {
      RouterUtils.goTo(RouterConstants.RICH_MENU_ROUTER_NAME);
    })
    .catch(error => {
      loading.value = false;
      toast.add({
        severity: "error",
        detail: "何かが間違っています。後でもう一度試してください",
        life: 3000,
      });
    });
};

const showMessageErrorImage = (no: number, message: string) => {
  previewBoxError.value[no]?.classList.remove("hidden");
  previewBoxError.value[no].innerHTML = message;
};

const hiddenMessageErrorImage = (no: number) => {
  previewBoxError.value[no].classList.add("hidden");
  previewBoxError.value[no].innerHTML = "";
};

const getExtFilename = filename => {
  return filename.split(".").pop();
};

const validateImage = n => {
  if (inputsUploadImage.value[n]?.files[0]) {
    let reader = new FileReader();
    const whiteListExt = ["png", "jpeg"];

    reader.readAsDataURL(inputsUploadImage.value[n].files[0]);
    reader.onload = evt => {
      let img = new Image();
      img.onload = () => {
        hiddenMessageErrorImage(n);
        if (!whiteListExt.includes(getExtFilename(inputsUploadImage.value[n].files[0].name))) {
          toast.add({
            severity: "error",
            detail: "Only png and jpeg files are allowed",
            life: 3000,
          });
        } else if (inputsUploadImage.value[n].files[0].size > 1000000) {
          toast.add({
            severity: "error",
            detail: "最大サイズファイル:1MB",
            life: 3000,
          });
        } else if (img.width < 800 || img.width > 2500) {
          toast.add({
            severity: "error",
            detail: "画像幅 (ピクセル):800から2500まで",
            life: 3000,
          });
        } else if (img.height < 250) {
          toast.add({
            severity: "error",
            detail: "画像高さ(ピクセル):250以上",
            life: 3000,
          });
        } else if (img.width / img.height < 1.45) {
          toast.add({
            severity: "error",
            detail: "画像アスペクト比(高さ／幅):1.45以上",
            life: 3000,
          });
        } else {
          previewBox.value[n].style.background = `url(${evt.target.result})`;
          previewBox.value[n].style.backgroundPosition = "center";
          previewBox.value[n].style.backgroundRepeat = "no-repeat";
          previewBox.value[n].style.backgroundSize = "100% 100%";
          previewBox.value[n].style.height = `${(300 * img.height) / img.width}px`;
        }
      };
      img.src = evt.target.result;
    };
  }
};

const validateURL = (value: string) => {
  set(showURLValidationError, false);

  if (value?.trim() === "" || !value) return;
  const urlPattern = /^(ftp|http|https):\/\/[^ "]+$/;
  const isURLValid = urlPattern.test(value);
  const result = !isURLValid && get(value) !== "";

  set(showURLValidationError, result);
  return result;
};

const validatePresent = value => {
  return validateErrors.value && (value == "" || value == null);
};

const validates = () => {
  validateErrors.value = false;

  if (menuTitle.value == "") {
    validateErrors.value = true;
  }

  if (get(showURLValidationError)) {
    set(validateErrors, true);
  }

  const totalMenuItems = [...Array(menuNumber.value).keys()].reduce((accumulator, index) => {
    let itemsCount = 1;
    if (selectedTemplates.value[index + 1]?.items != undefined) {
      itemsCount = Object.keys(selectedTemplates.value[index + 1].items).length;
    }
    return accumulator + itemsCount;
  }, 0);

  if (totalMenuItems > Object.keys(selectedItemsContent.value).length) {
    validateErrors.value = true;
  }

  if (totalMenuItems > Object.keys(selectedItemsType.value).length) {
    validateErrors.value = true;
  }

  const totalFileSelected = [...Array(menuNumber.value).keys()].reduce((accumulator, index) => {
    if (inputsUploadImage.value[index + 1]?.files.length < 1) {
      showMessageErrorImage(index + 1, "このフィールドは必須です。");
    }
    return accumulator + inputsUploadImage.value[index + 1]?.files.length;
  }, 0);

  if (totalFileSelected < menuNumber.value) {
    validateErrors.value = true;
  }
  return validateErrors.value;
};

const openSelectFile = n => {
  inputsUploadImage.value[n].click();
};

onBeforeMount(async () => {
  await set(clinicId, await inject("clinicId"));
  const { data: menuTemplates } =
    (await RichMenuTemplateServices.getRichMenuTemplates()) as unknown as ILinesMenuTemplate[];
  richmenuTemplates.value = menuTemplates.value;
});

return (_ctx: any,_cache: any) => {
  const _component_InputText = _resolveComponent("InputText")!
  const _component_Dropdown = _resolveComponent("Dropdown")!
  const _component_Button = _resolveComponent("Button")!
  const _component_dropdown = _resolveComponent("dropdown")!
  const _component_Card = _resolveComponent("Card")!
  const _component_Dialog = _resolveComponent("Dialog")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      (isSuccess.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _createVNode(_unref(InlineMessage), {
              class: "w-100",
              severity: "success",
              icon: ""
            }, {
              default: _withCtx(() => [
                _createTextVNode("保存が完了しました")
              ]),
              _: 1
            })
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_5, [
        _hoisted_6,
        _createVNode(_component_InputText, {
          id: "menu-title",
          class: "p-float-label flex border-round-md border-200 w-9",
          placeholder: "タイトルテキスト",
          modelValue: menuTitle.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((menuTitle).value = $event))
        }, null, 8, ["modelValue"]),
        (validatePresent(menuTitle.value))
          ? (_openBlock(), _createElementBlock("small", _hoisted_7, "このフィールドは必須です。"))
          : _createCommentVNode("", true)
      ]),
      _hoisted_8,
      _createElementVNode("div", _hoisted_9, [
        _createElementVNode("div", _hoisted_10, [
          _createVNode(_unref(RadioButton), {
            modelValue: menuType.value,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((menuType).value = $event)),
            inputId: "single-menu",
            name: "menuType",
            value: "single",
            onChange: onChangeTabNumber
          }, null, 8, ["modelValue"]),
          _createElementVNode("label", {
            for: "single-menu",
            class: _normalizeClass(["flex algin-items-center", { 'text-orange': menuType.value === 'single' }])
          }, [
            (menuType.value === 'single')
              ? (_openBlock(), _createElementBlock("span", _hoisted_11))
              : (_openBlock(), _createElementBlock("span", _hoisted_12)),
            _createTextVNode(" 単一タブ ")
          ], 2)
        ]),
        _createElementVNode("div", _hoisted_13, [
          _createVNode(_unref(RadioButton), {
            modelValue: menuType.value,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((menuType).value = $event)),
            inputId: "tabs-menu",
            name: "menuType",
            value: "tabs",
            onChange: onChangeTabNumber
          }, null, 8, ["modelValue"]),
          _createElementVNode("label", {
            for: "tabs-menu",
            class: _normalizeClass(["flex algin-items-center", { 'text-orange': menuType.value === 'tabs' }])
          }, [
            (menuType.value === 'tabs')
              ? (_openBlock(), _createElementBlock("span", _hoisted_14))
              : (_openBlock(), _createElementBlock("span", _hoisted_15)),
            _createTextVNode(" 複数タブ ")
          ], 2)
        ])
      ]),
      (menuType.value == 'tabs')
        ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
            _createElementVNode("div", _hoisted_17, [
              _hoisted_18,
              _createElementVNode("div", _hoisted_19, [
                _createVNode(_component_Dropdown, {
                  modelValue: selectedNumberOfTabs.value,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((selectedNumberOfTabs).value = $event)),
                  options: numberOfTabs.value,
                  optionLabel: "name",
                  optionValue: "value",
                  onChange: onChangeTabNumber,
                  class: "w-full md:w-14rem p-inputtext"
                }, null, 8, ["modelValue", "options"])
              ])
            ]),
            _createElementVNode("div", _hoisted_20, [
              _hoisted_21,
              _createElementVNode("div", _hoisted_22, [
                _createVNode(_unref(InputNumber), {
                  modelValue: tabHeight.value,
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((tabHeight).value = $event)),
                  inputId: "tab-height",
                  min: 10,
                  max: 50,
                  showButtons: "",
                  buttonLayout: "horizontal",
                  suffix: "%",
                  decrementButtonClass: "p-button-danger",
                  incrementButtonClass: "p-button-success",
                  incrementButtonIcon: "pi pi-plus",
                  decrementButtonIcon: "pi pi-minus",
                  allowEmpty: false,
                  class: "w-full md:w-14rem"
                }, null, 8, ["modelValue"])
              ])
            ])
          ]))
        : _createCommentVNode("", true),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(menuNumber.value, (n) => {
        return (_openBlock(), _createBlock(_component_Card, {
          key: n,
          class: "tab-card"
        }, {
          title: _withCtx(() => [
            _createElementVNode("span", _hoisted_23, " タブ " + _toDisplayString(n), 1)
          ]),
          content: _withCtx(() => [
            _createElementVNode("div", _hoisted_24, [
              _createElementVNode("div", _hoisted_25, [
                _createElementVNode("div", _hoisted_26, [
                  _createElementVNode("div", {
                    class: "template-preview-wrapper mb-4",
                    ref_for: true,
                    ref: 
                    el => {
                      previewBox.value[n] = el;
                    }
                  
                  }, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(selectedTemplates.value[n]?.items || defaultTemplate.value.items, (block, blockName) => {
                      return (_openBlock(), _createElementBlock("div", {
                        class: "template-block flex align-items-center justify-content-center flex-wrap",
                        key: block.position,
                        style: _normalizeStyle(blockStyle(block))
                      }, _toDisplayString(blockName), 5))
                    }), 128)),
                    _createElementVNode("small", {
                      class: "p-error text-sm hidden",
                      ref_for: true,
                      ref: 
                      el => {
                        previewBoxError.value[n] = el;
                      }
                    
                    }, null, 512)
                  ], 512),
                  _createElementVNode("div", _hoisted_27, [
                    _createVNode(_component_Button, {
                      class: "p-button border-round select-template-btn mr-3",
                      onClick: ($event: any) => (openTemplatePopup(n))
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(" テンプレートを選択 ")
                      ]),
                      _: 2
                    }, 1032, ["onClick"]),
                    _createVNode(_component_Button, {
                      class: "p-button border-round select-template-image-btn",
                      onClick: ($event: any) => (openSelectFile(n))
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(" 画像アップロード ")
                      ]),
                      _: 2
                    }, 1032, ["onClick"]),
                    _createElementVNode("input", {
                      type: "file",
                      accept: "image/png, image/jpeg",
                      class: "hidden",
                      ref_for: true,
                      ref: 
                      el => {
                        inputsUploadImage.value[n] = el;
                      }
                    ,
                      onChange: ($event: any) => (validateImage(n))
                    }, null, 40, _hoisted_28)
                  ])
                ]),
                _createElementVNode("div", _hoisted_29, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(selectedTemplates.value[n]?.items || defaultTemplate.value.items, (block, blockName) => {
                    return (_openBlock(), _createElementBlock("div", {
                      class: "menu-item-wrapper border-round",
                      key: block.position
                    }, [
                      _createElementVNode("h5", _hoisted_30, [
                        _hoisted_31,
                        _createElementVNode("span", _hoisted_32, _toDisplayString(blockName), 1)
                      ]),
                      _createElementVNode("div", _hoisted_33, [
                        _hoisted_34,
                        _createElementVNode("div", _hoisted_35, [
                          _createVNode(_component_dropdown, {
                            class: "w-full text-base text-color surface-overlay p-2 border-1 border-solid surface-border border-round appearance-none focus:border-primary line-height-1",
                            options: menuItemTypes.value,
                            optionLabel: "name",
                            modelValue: selectedItemsType.value[`${blockName}-${n}`],
                            "onUpdate:modelValue": ($event: any) => ((selectedItemsType.value[`${blockName}-${n}`]) = $event)
                          }, null, 8, ["options", "modelValue", "onUpdate:modelValue"]),
                          (validatePresent(selectedItemsType.value[`${blockName}-${n}`]))
                            ? (_openBlock(), _createElementBlock("small", _hoisted_36, "このフィールドは必須です。"))
                            : _createCommentVNode("", true)
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_37, [
                        _createElementVNode("label", {
                          for: `item-content-${blockName}-${n}`
                        }, [
                          _createTextVNode("リンク"),
                          _hoisted_39
                        ], 8, _hoisted_38),
                        _createElementVNode("div", _hoisted_40, [
                          _createVNode(_component_InputText, {
                            id: `item-content-${blockName}-${n}`,
                            class: "text-base text-color surface-overlay p-2 border-1 border-solid surface-border border-round appearance-none outline-none focus:border-primary w-full",
                            modelValue: selectedItemsContent.value[`${blockName}-${n}`],
                            "onUpdate:modelValue": ($event: any) => ((selectedItemsContent.value[`${blockName}-${n}`]) = $event),
                            placeholder: "URLテキスト"
                          }, null, 8, ["id", "modelValue", "onUpdate:modelValue"]),
                          (validatePresent(selectedItemsContent.value[`${blockName}-${n}`]))
                            ? (_openBlock(), _createElementBlock("small", _hoisted_41, "このフィールドは必須です。"))
                            : (validateURL(selectedItemsContent.value[`${blockName}-${n}`]))
                              ? (_openBlock(), _createElementBlock("small", _hoisted_42, " 間違った形式。 "))
                              : _createCommentVNode("", true)
                        ])
                      ])
                    ]))
                  }), 128))
                ])
              ])
            ])
          ]),
          _: 2
        }, 1024))
      }), 128)),
      _createElementVNode("div", _hoisted_43, [
        _createVNode(_component_Button, {
          label: "キャンセル",
          class: "p-button-light btn-cancel mr-3",
          onClick: backToList
        }),
        _createVNode(_component_Button, {
          class: "btn-new mt-3 border-transparent flex justify-content-center",
          onClick: createRichMenu,
          loading: loading.value
        }, {
          default: _withCtx(() => [
            _createTextVNode(" リッチメニューを保存 ")
          ]),
          _: 1
        }, 8, ["loading"])
      ])
    ]),
    _createVNode(_component_Dialog, {
      visible: visible.value,
      "onUpdate:visible": _cache[6] || (_cache[6] = ($event: any) => ((visible).value = $event)),
      modal: "",
      header: "テンプレートを選択",
      style: { width: '803px' }
    }, {
      footer: _withCtx(() => [
        _createVNode(_component_Button, {
          label: "キャンセル",
          class: "p-button-light mr-3",
          onClick: _cache[5] || (_cache[5] = ($event: any) => (visible.value = false))
        }),
        _createVNode(_component_Button, {
          label: "登録",
          class: "mr-2",
          onClick: handleSelectTemplate
        })
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_44, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(richmenuTemplates.value, (template) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "col-3",
              key: template.id
            }, [
              _createElementVNode("div", {
                class: _normalizeClass(["template-wrapper m-2", { selected: isSelectedTemplate(template.id) }]),
                onClick: chooseTemplate,
                "data-id": template.id
              }, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(template.items, (item, blockName) => {
                  return (_openBlock(), _createElementBlock("div", {
                    class: "template-block flex align-items-center justify-content-center flex-wrap",
                    key: item.position,
                    style: _normalizeStyle(blockStyle(item))
                  }, _toDisplayString(blockName), 5))
                }), 128))
              ], 10, _hoisted_45)
            ]))
          }), 128))
        ])
      ]),
      _: 1
    }, 8, ["visible"]),
    _createVNode(_unref(Toast), { position: "top-center" })
  ]))
}
}

})